<template>
<div class="vertical_center">
<div class=" p-4 shadow-2 border-round w-full " >
    <div class="text-center mb-5">
        
        <div class="text-900 text-3xl font-medium mb-3 text-primary">{{$store.state.languages.lang_phrases.hosgeldiniz}}</div>
        <!--<span class="text-600 font-medium line-height-3">Don't have an account?</span>
        <a class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create today!</a>-->
    </div>

    <div>
        
    	<form @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">



        <span class="p-float-label mb-5">
			<InputText id="email" type="text" v-model.trim="v$.email.$model" class="w-full p-inputtext-lg" :class="{'p-invalid':v$.email.$invalid && submitted}" autofocus/>
			<label for="email">Email</label>

			<span v-if="v$.email.$error && submitted">
	            <span id="email-error" v-for="(error, index) of v$.email.$errors" :key="index">
	            <small class="p-error">{{error.$message}}</small>
	            </span>
	        </span>
        	<small v-else-if="(v$.email.$invalid && submitted) || v$.email.$pending.$response" class="p-error">{{v$.email.required.$message.replace('Value', 'Email')}}</small>
		</span>


		<span class="p-float-label mb-5">
			<InputText id="password" type="password" v-model.trim="password" class="w-full p-inputtext-lg" />
			<label for="password">{{$store.state.languages.lang_phrases.sifre}}</label>
		</span>

        <span v-if="showerror" class="flex align-items-center justify-content-between mb-6">

         <small class="p-error">{{errormessage}}</small>
        </span>

       

        <div class="flex align-items-center justify-content-end mb-6">
            
            <router-link to="/reset-password" class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">{{$store.state.languages.lang_phrases.sifremi_unuttum}}</router-link>
        </div>

        <Button :label="$store.state.languages.lang_phrases.giris" icon="pi pi-user" class="w-full p-button-primary" :loading="$store.state.ui.submitting" type="submit"></Button>
    	</form>
    </div>
</div>
</div>
</template>

<script>
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {

  name: 'Login',
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
    	checked:false,
    	email:"",
    	password:"",
    	loading:false,
    	showerror:false,
    	submitted: false,
        errormessage:null,
    }
  },
  validations() {
    return {
        email: {
            required,
            email
        },
        password: {
            required
        },
    }
  },
  mounted()
  {
  	
  },
  methods:{
  	handleSubmit(isFormValid)
  	{
  		this.submitted = true;

        if (!isFormValid) {
        	this.loading = false
            return;
        }
        this.login();
  	},
  	testget()
  	{

  	},
  	login()
    {
      
      this.loading = true
      this.showerror = false     
      let formdata = new FormData()
      formdata.append("email",this.email)
      formdata.append("password",this.password)
      this.generalSubmission(formdata,"login",this.afterLogin)
    },
    async afterLogin(response)
    {
        this.loading = false
        if(response.status==400 ||response.status==401)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        } 

        if(response.status==404)
        {
            this.showerror = true
            this.errormessage = "email address is not valid"
        }    	
    	if(response.data && response.data.token)
    	{
    		await this.$store.dispatch('auth/setToken',response.data.token)
    		await localStorage.setItem("vrf_token",response.data.token);
            await this.$store.dispatch('ui/setSubmitting',true) 
    		await this.getUserData()
    		await setTimeout(async ()=>{
                await this.$store.dispatch('ui/setSubmitting',false) 
                if(this.$store.state.auth.redirectpath)
                {
                    let path = await this.$store.state.auth.redirectpath.fullPath
                    await this.$store.dispatch('auth/setRedirectPath',null)
                    await this.$router.push({ path: path })
                }
                else
                {
                    await this.$router.push({ name: 'App', params: { uuid:this.$store.state.auth.user.uuid } })
                }
	           
	        },10)
    	}
    }
  }
};
</script>

<style lang="css" scoped>
</style>